import { render, staticRenderFns } from "./LocalDids.vue?vue&type=template&id=7a6b339f&scoped=true&"
import script from "./LocalDids.vue?vue&type=script&lang=js&"
export * from "./LocalDids.vue?vue&type=script&lang=js&"
import style0 from "./LocalDids.vue?vue&type=style&index=0&lang=css&"
import style1 from "./LocalDids.vue?vue&type=style&index=1&id=7a6b339f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6b339f",
  null
  
)

component.options.__file = "LocalDids.vue"
export default component.exports